webpackJsonp([15480069851703],{

/***/ 820:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tutorials-examples-microwave-a0e39f21c11f6a62c5ab.js